export default __webpack_public_path__ + "static/media/alert-circle.17ebcb42.svg";